import { createTheme, ThemeProvider } from "@mui/material";
import { ReactNode } from "react";
import useSkpTheme from "../../hooks/useSkpTheme";
import { cssVar } from "../../utils/cssVar";
import { UploadStatus, useUploadStatus } from "../uploadStatus";

type UploadDialogThemeProviderProp = {
  children: ReactNode;
};

export const UploadDialogThemeProvider = ({
  children,
}: UploadDialogThemeProviderProp) => {
  useSkpTheme();

  const uploadStatus: UploadStatus = useUploadStatus();

  let uploadProgressBarColor = cssVar(
    "--ongoing-upload-circular-progress-bar-color"
  );

  if (uploadStatus === UploadStatus.success) {
    uploadProgressBarColor = cssVar(
      "--post-succesful-upload-circular-progress-bar-color"
    );
  } else if (
    uploadStatus === UploadStatus.failed ||
    uploadStatus === UploadStatus.aborted
  ) {
    uploadProgressBarColor = cssVar(
      "--post-failed-upload-circular-progress-bar-color"
    );
  }
  const uploadDialogTheme = createTheme({
    palette: {
      primary: {
        main: cssVar("--primary-color"),
      },
      secondary: {
        main: cssVar("--primary-light-color"),
      },
    },
    components: {
      MuiCircularProgress: {
        styleOverrides: {
          circle: {
            strokeWidth: 2.65,
            strokeLinecap: "round",
          },
          determinate: {
            transition: "color 1.5s cubic-bezier(0.4, 0, 0.6, 1)",
            color: uploadProgressBarColor,
            position: "absolute",
            top: -2,
            left: -1.7,
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: cssVar("--primary-color"),
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          outlined: {
            borderRadius: 20,
          },
          contained: {
            color: "white",
            borderRadius: "var(--send-button-border-radius)",
            paddingY: "var(--send-button-vertical-padding)",
            paddingX: "var(--send-button-horizontal-padding)",
            textTransform: "none",
            ":hover": {
              backgroundColor: "var(--send-button-hover-bg-color)",
              filter: "brightness(0.95)",
            },
          },
        },
      },
    },
  });

  return <ThemeProvider theme={uploadDialogTheme}>{children}</ThemeProvider>;
};
